import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Table } from 'reactstrap';

import { compose } from 'recompose';

import { withFirebase } from '../../components/Firebase';
import { withAuthorization } from '../../components/Session';
import * as ROUTES from '../../constants/routes';
import * as CHAVES from '../../constants/chaves';

import MenuAdm from '../../menu/menuAdm';

const INITIAL_STATE = {
    usuarioLogado: {},
    chamado: {},
    profissionais: [],
    profissionais_selecionados: [],
    userAutenticado: {},
    escolhido: false,
    profissionalEscolhido: {},
    prof_escolhidos: 0,
    modal: false,
};

class EscolherProfissionalBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };

        this.onChange = this.onChange.bind(this);
        this.solicitarOrcamento = this.solicitarOrcamento.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        this.listenerUserAutenticado = this.props.firebase.auth.onAuthStateChanged(userAutenticado => {
            userAutenticado
                ? this.setState({ userAutenticado })
                : this.setState({ userAutenticado: null });
        });
        // carrega Usuário
        this.listenerUser = this.props.firebase.solicitante(this.props.firebase.auth.currentUser.uid).once('value').then((snapshot) => {
            const usuarioLogado = snapshot.val();
            this.setState({
                usuarioLogado
            })
            this.carregaChamado();
        });
    }

    carregaChamado = () => {
        // Carrega solicitação não concluido
        // this.listenerAbrirChamado = this.props.firebase.abrirChamadoSolicitante(this.props.firebase.auth.currentUser.uid).on('value', snapshot => {
        this.props.firebase.abrirChamadoSolicitante(this.props.firebase.auth.currentUser.uid).on('value', snapshot => {
            const chamado = snapshot.val();
            const chamadoList = Object.keys(chamado).map(key => ({
                ...chamado[key],
                uid: key,
            }));
            chamadoList.map(chamado => {
                if (!chamado.concluido) {
                    this.setState({
                        chamado,
                    });
                    this.carregaProfissionais();
                }
                // remover alerta
                return true;
            })
        });
    }

    carregaProfissionais = () => {
        // Carrega profissioanis que podem atender
        const profissionaisValidados = [];
        this.props.firebase.profissionaisPorCidadePorAreaAtuacao()
            .child(this.state.usuarioLogado.cidade.uid)
            .child(this.state.chamado.areaDeAtuacao.uid).on('value', snapshop => {
                const profissional = snapshop.val();

                const profissionalList = Object.keys(profissional).map(key => ({
                    ...profissional[key],
                    uid: key,
                }))

                // remover profissionais não validados && possi saldo suficiente
                profissionalList.map(prof => {
                    try {
                        let saldoProfissional = prof.saldo.split(",")[0];

                        //if (prof.validado && saldoProfissional >= this.state.chamado.areaDeAtuacao.valor)  {
                        profissionaisValidados.push(prof)
                        //}
                    } catch (e) {

                    }
                    // remover alerta
                    return true;
                });
                this.setState({
                    profissionais: profissionaisValidados,
                });
            })
    }

    onSubmit = event => {
        event.preventDefault();
    }

    onChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        const chamadoTemp = this.state.chamado;

        if (value) {
            //colocar na lista de selecionados
            // existe profissionais selecionados ?
            if (chamadoTemp.profissionais_selecionados) {
                if (chamadoTemp.profissionais_selecionados.length > 1) {
                    this.setState({
                        modal: true,
                    })
                } else {
                    // adicionar profissional na lista
                    this.state.profissionais.map(prof => {
                        if (prof.uid == name) {
                            chamadoTemp.profissionais_selecionados = [...chamadoTemp.profissionais_selecionados, prof];
                        }
                    });
                }
            } else {
                this.state.profissionais.map(prof => {
                    if (prof.uid == name) {
                        chamadoTemp.profissionais_selecionados = [prof];
                    }
                })
            }

        } else {
            //remover da lista de selecionados
            // percorre a lista e remove o profissional
            let profissionais = [];
            chamadoTemp.profissionais_selecionados.map(prof => {
                if (prof.uid != name) {
                    profissionais = [...profissionais, prof];
                }
            });
            chamadoTemp.profissionais_selecionados = profissionais;
        }
        this.setState({
            profissionais_selecionados: chamadoTemp.profissionais_selecionados
        });

    }


    solicitarOrcamento = () => {
        var chamadoTemp = this.state.chamado;

        this.props.firebase.abrirChamadoSolicitante(this.props.firebase.auth.currentUser.uid).off();

        // apagar chamado em ChamadosPorSolicitanteEmAberto
        this.props.firebase.chamadosPorSolicitanteEmAberto()
            .child(this.props.firebase.auth.currentUser.uid)
            .child(this.state.chamado.uid).set(null);

        chamadoTemp.status = CHAVES.CHAMADOS_POR_SOLICITANTE_EM_ANALISE;

        // atualiza chamado
        this.props.firebase.chamadosPorSolicitanteEmAnalise()
            .child(this.props.firebase.auth.currentUser.uid)
            .child(chamadoTemp.uid)
            .set(chamadoTemp);

        // Altera status do chamado
        chamadoTemp.status = CHAVES.CHAMADOS_POR_PROFISSIONAL_EM_ANALISE;

        // envia chamado para os profissionais 
        chamadoTemp.profissionais_selecionados.map(prof => {

            //salva na chave
            this.props.firebase.chamadosPorProfissionalEmAnalise()
                .child(prof.uid)
                .child(chamadoTemp.uid)
                .set(chamadoTemp);

            const mensagem = {
                titulo: "Você foi escolhido",
                mensagem: this.state.userAutenticado.displayName + " escolheu você para fazer um orçamento",
                uid: "123456789"
            }
            // envia mensagem
            this.props.firebase.alertasPorUid()
                .child(prof.uid)
                .child(mensagem.uid)
                .set(mensagem)
        })

        this.props.history.push(ROUTES.MINHAS_SOLICITACOES);
    }

    render() {
        const { profissionais, escolhido, profissionalEscolhido, modal } = this.state;
        return (
            <div>
                {modal &&
                    <div>
                        <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                            <ModalHeader toggle={this.toggle}>Alerta</ModalHeader>
                            <ModalBody>Você já selecionou o máximo de profissionais permitidos</ModalBody>
                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggle}>OK</Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                }
                <MenuAdm />
                <header className="masthead">
                    <div className="container h-100">
                        <div className="divBranca">
                            <form onSubmit={this.onSubmit}>
                                <div className="row divBranca">
                                    <div className="col">
                                        <div className="row">
                                            <div className="col-sm-4 col-md-2 direita"><img src={process.env.PUBLIC_URL + './img/expedito.jpg'} width='100' alt='' /></div>
                                            <div className="col-sm-8 col-md-10" >
                                                <h3>Escolha até dois profissionais para lhe fazer um orçamento</h3>
                                                {
                                                    this.state.profissionais_selecionados.length > 0 &&
                                                    <div>
                                                        <p>Profissionais escolhidos</p>
                                                        <div className="row">
                                                            <div className="col">
                                                                {this.state.profissionais_selecionados.map(prof => (
                                                                    <div>
                                                                        {prof.nome} {prof.sobrenome}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <div className="col direita">
                                                                <Button
                                                                    color="success"
                                                                    disabled={escolhido}
                                                                    onClick={() => this.solicitarOrcamento()}>Solicitar Orçamento</Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="row">
                                            <Table striped>
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>Nome</th>
                                                        <th>Trabalha com</th>
                                                        <th>Experiência</th>
                                                        <th>Comentários</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        profissionais.map(prof => (
                                                            <tr>
                                                                <td>
                                                                    <input
                                                                        name={prof.uid}
                                                                        type="checkbox"
                                                                        checked={this.state.isGoing}
                                                                        onChange={this.handleInputChange} />
                                                                </td>
                                                                <td>
                                                                    <p><b>{prof.nome} {prof.sobrenome}</b></p>
                                                                    <p>{prof.bairro} - {prof.cidade}</p>
                                                                </td>
                                                                <td>
                                                                    {
                                                                        prof.areasDeAtuacao.map(area => (
                                                                            <span>{area.nome}, </span>
                                                                        ))
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        prof.curriculo &&
                                                                        (
                                                                            <p>{2019 - prof.curriculo.anoInicioProfissao} anos de profissão </p>
                                                                        )
                                                                    }
                                                                </td>
                                                                <td>
                                                                    {
                                                                        prof.curriculo.comentarios &&
                                                                        (
                                                                            <p> <b>Comentários: </b> <br />
                                                                                <ul>{
                                                                                    prof.curriculo.comentarios.map(coment => (
                                                                                        <li>{coment}</li>
                                                                                    ))
                                                                                }</ul>
                                                                            </p>
                                                                        )
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </header>
            </div>
        )
    }
}

const condition = authUser => !!authUser;

const EscolherProfissional = compose(
    withFirebase,
    withAuthorization(condition),
)(EscolherProfissionalBase);


export default EscolherProfissional;